import { useEffect } from 'react'
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil'
import {
  AllCheckState,
  TermsAgreeState,
  RecoilStateList,
  uiData,
  uiTermsStyle
} from 'src/recoil/ui'
import {
  AllTermsContainer,
  CheckIcon,
  EachTermsContainer,
  EachTermsItems,
  TermsAgreeContents,
  TermsAgreeWrap,
} from 'src/styles/views/join/Terms'
import { JoinTermsDetail } from 'src/types/type'

const Terms = (): JSX.Element => {
  const { TelType, AllTermsAgree, termsAgree, TermsData, isAgreeAllRequiredTerms } = useRecoilValue(RecoilStateList)
  const setAllTermsAgree = useSetRecoilState(AllCheckState)
  const setTermsAgree  = useSetRecoilState(TermsAgreeState)
  const ResetJoinTerms = useResetRecoilState(TermsAgreeState)
  const { borderRadius } = useRecoilValue(uiTermsStyle)

  const {
    layoutsTerms: { actColor: checkColor },
  } = useRecoilValue(uiData)
  const termsOpen = (order: number): void => {
    // 약관 보기
    const width: number = 400
    const height: number = 600

    const url: string | undefined = `/terms/${TelType}/${TermsData.TermsIdx}/${order}`

    if (url) {
      window.open(url, '_blank', `width=${width}, height=${height}`)
    }
  }

  const AllTerms = (): void => {
    // 전체동의
    const copyArray = [...termsAgree]
    if (!AllTermsAgree) {
      // 전체동의시 필수선택 체크
      TermsData?.Terms.forEach((value: JoinTermsDetail) => {
        if (value.Order !== undefined && value.Required === 1) {
          copyArray[value.Order - 1] = 1
        }
      })
    } else {
      copyArray.fill(0)
    }
    setTermsAgree(copyArray)
    setAllTermsAgree((AllTermsAgree) => !AllTermsAgree)
  }

  // 개별동의
  const EachTerms = (order: number): void => {
    const copyArray = [...termsAgree]
    copyArray[order - 1] = termsAgree[order - 1] === 1 ? 0 : 1
    setTermsAgree(copyArray)
  }

  useEffect(() => {
    ResetJoinTerms()
    setAllTermsAgree(false)
    setTermsAgree(Array(9).fill(0))
  }, [ResetJoinTerms, TelType, TermsData, setAllTermsAgree, setTermsAgree])

  useEffect(() => {
    setAllTermsAgree(isAgreeAllRequiredTerms)
  }, [isAgreeAllRequiredTerms, setAllTermsAgree])

  return (
    <TermsAgreeWrap borderRadius={borderRadius}>
      <TermsAgreeContents>
        <AllTermsContainer checkColor={checkColor} onClick={AllTerms} active={AllTermsAgree}>
          <span>
            <CheckIcon checkColor={checkColor} primary />
          </span>
          <p>전체동의</p>
        </AllTermsContainer>
        <EachTermsContainer>
          {TermsData?.Terms.map((terms: JoinTermsDetail, index: number) => (
            terms.Order !== undefined &&
            <EachTermsItems key={index} onClick={() => EachTerms(terms.Order!)}>
              <CheckIcon
                checkColor={checkColor}
                active={termsAgree[terms.Order - 1] === 1}
              />
              <p
                onClick={() => {termsOpen(terms.Order!) }}
              >
                {terms.Title}
                {terms.Required === 1 ? '' : '(선택)'}
              </p>
            </EachTermsItems>
          ))}
        </EachTermsContainer>
      </TermsAgreeContents>
    </TermsAgreeWrap>
  )
}
export default Terms
